<div class="p-5 flex flex-col gap-3">
    <h2 class="text-2xl">Create sport</h2>
    <form (ngSubmit)="onSubmit()" [formGroup]="sportForm" class="flex flex-col gap-3">
        <mat-form-field appearance="outline" class="w-full">
            <mat-label>Sport name</mat-label>
            <input type="text" matInput [formControl]="sportForm.controls.name" />
            <mat-error *ngIf="ValidationHelperService.isInvalid(sportForm.controls.name)">
                {{
                    ValidationHelperService.getErrorMessage(sportForm.controls.name)
                }}
            </mat-error>
        </mat-form-field>

        <div class="flex justify-end">
            <button mat-flat-button color="primary">
                Save
            </button>
        </div>
    </form>
</div>
